<navigation></navigation>
<router-outlet></router-outlet>
<progress-indicator></progress-indicator>
<session-error></session-error>
<alert></alert>